import ViewActiveModal from './ViewActiveModal';

export default ViewActiveModal;
